import React from 'react'
import { Grid, Cell, TextField, SelectField } from 'react-md'

function SFForm({fields, data, handleFormChange, height}) {
  return (
    <div style={{height: height ? height : '350px'}}>
        <Grid>
            {fields?.map((field, index) => {
                return <Cell size={6}>
                <label>{field.name} 
                {/* {field.isRequired ? "(*)" : ""} */}
                </label>
                {field.type === "text" || field.type === "number" ? 
                    <TextField 
                        id={field.id}
                        name={field.name + field.isRequired ? "*" : ""}
                        type={field.type}
                        disabled={field.disabled}
                        value={data[field.id]}
                        onChange={(val) => {
                            handleFormChange(field.id, val)
                        }}
                        required={field.isRequired}
                        errorText="This field is required."
                        placeholder={field.placeholder ? field.placeholder : field.name}
                    />
                : null}

                {field.type === 'select' ? 
                  <div className="w-full">
                    <SelectField
                        id={field.id}
                        placeholder={field.placeholder ? field.placeholder : field.name}
                        menuItems={field.items}
                        simplifiedMenu={true}
                        value={data[field.id] || field.defaultValue}
                        style={{
                            width:'100%'
                        }}
                        required={field.isRequired}
                        errorText="This field is required."
                        onChange={(val) => {
                            handleFormChange(field.id, val)
                        }}
                        />
                  </div>
                : null}
            </Cell>
            })}
            
        </Grid>
    </div>
  )
}

export default SFForm
